import type { GraphQLError } from "graphql";

export const isCartNotFoundError = (errors: GraphQLError[] | undefined): boolean => {
    if (!errors?.length) return false;
    return errors.some((error) => error?.message?.includes("was not found in store"));
};
